export const AUTH_LOGIN_URL = "/auth/login";
export const AUTH_REGISTER_URL = "/auth/register";
export const AUTH_FORGOT_PASSWORD_URL = "/auth/forgot-password";
export const AUTH_RESET_PASSWORD_URL = "/auth/reset-password";
export const AUTH_SETUP_PASSWORD_URL = "/auth/setup-password";

export const ORGANIZATION_REQUESTS_URL = "/user-request";
export const UPDATE_ORGANIZATION_REQUESTS_URL = "/user-request/:id";
export const ORGANIZATION_REQUESTS_STATIC_URL = "/user-request/static";

export const ORGANIZATIONS_URL = "/organizations";
export const UPDATE_ORGANIZATIONS_URL = "/organizations/:id";
export const ORGANIZATIONS_STATIC_URL = "/organizations/static";

export const RIGHT_PERMISSIONS_URL = "/rights/permissions";

export const BASE_URL = "/assets/images";
export const BASE_FILE_URL = "/assets/files";

